/**
 * ArrowIcon - inline right-arrow SVG for CTAs/links (Editorial Authority).
 * Replaces literal "->" text (looked like a placeholder). Uses currentColor
 * so it inherits the button/link text color; sized ~1em to sit on the
 * baseline. aria-hidden (decorative - the link text carries meaning).
 * Hover nudge handled in landing-editorial.css (.ed-arrow translateX).
 */
export function ArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className ? `ed-arrow ${className}` : 'ed-arrow'}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M2.5 8h9.5M8.5 4l4 4-4 4"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
